import * as React from 'react';
import { connect } from 'react-redux';
import { Column, Row } from 'hedron';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import { home } from '../../helpers/routes';
import {
  AboutUsWelcome,
  AboutUsLearnMore,
  AboutUsInsiders,
  AboutUsBeforeItalist,
  AboutUsAfterItalist,
  AboutUsVideo
} from '../../components_common/AboutUs';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import { ShopAnchor } from '../../components_mobile/components/AboutUs';
import { Wrapper } from '../css_global/utils.css';
import Store from '../../common/models/Store';

const mapStateToProps = ({ api: { s3BasePath } }: Store) => ({
  s3BasePath
});

const AboutUsComponent: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
  s3BasePath: string;
}> = ({ buildUrlWithCountry, s3BasePath }) => (
  <Wrapper>
    <VerticalSpacer height="60px" />
    <AboutUsWelcome />
    <VerticalSpacer height="40px" />
    <AboutUsInsiders />
    <VerticalSpacer height="60px" />
    <Row>
      <Column fluid lg={8} md={8}>
        <Wrapper margin="0 25px 0 0">
          <AboutUsBeforeItalist />
        </Wrapper>
      </Column>
      <Column fluid lg={4} md={4}>
        <Wrapper margin="0 0 0 25px">
          <img src={`${s3BasePath}about_us/milan_desktop.png`} style={{ maxWidth: '100%' }} />
        </Wrapper>
      </Column>
    </Row>
    <Row alignContent="center" alignItems="center">
      <Column fluid lg={6} md={6}>
        <Wrapper margin="70px 25px 0 0">
          <img src={`${s3BasePath}about_us/mock_desktop.png`} style={{ maxWidth: '100%' }} />
        </Wrapper>
      </Column>
      <Column fluid lg={6} md={6}>
        <Wrapper margin="0 0 0 25px">
          <AboutUsAfterItalist />
        </Wrapper>
      </Column>
    </Row>
    <VerticalSpacer height="40px" />
    <AboutUsLearnMore />
    <VerticalSpacer height="40px" />
    <AboutUsVideo />
    <VerticalSpacer height="35px" />
    <Wrapper textAlign="center">
      <ShopAnchor href={buildUrlWithCountry(home)} margin="0 5%" width="300px">
        SHOP NOW
      </ShopAnchor>
    </Wrapper>
    <VerticalSpacer height="195px" />
  </Wrapper>
);

const AboutUs = connect(mapStateToProps)(AboutUsComponent);
export default withCountryCode(AboutUs);
